import { SCENE_INTERACTION } from "../../../constants/scene";
import { ICON } from "../../Icons/Icons";
import { SCENE_EVENTS } from "../../MVC/Model";
import { BottomNavbarCenterMenu, BottomNavbarRightMenu } from "../../Navbar/BottomNavBarMenu";
import { CHAT_EVENTS } from "../../../constants/chat";
import { CHAT_NOTIFICATION } from "../../Chat/ChatNotifications";
import { isFullscreen, toggleFullscreen } from "../../engine/helpers/worldHelpers";
import VolumeAnalyser from "../AudioAnalyser/VolumeAnalyser";
import { SOCKET_EVENTS } from "../../../socket/Events";
import { FEATURE_NAMES } from "../../MVC/rolesHelper";
import { ANT_MEDIA_SERVER_BAGELSS_EVENTS } from "../../WebRTC/constants";
import { OwnVapiMenuSubtitles } from "./OwnVapiMenuSubtitles";

export class MeetingChatControls extends BottomNavbarRightMenu {
  static selector() {
    return $('#meeting-mode__right-control')
  }

  static template() {
    return `
<section
  id="meeting-mode__right-control"
  class="world-bottom-nav__area world-bottom-nav__right_area"
  style="display: none;"
>
  <div class="world-bottom-nav__area__item meeting-mode__controls__chat">
    ${ICON.CHAT}
    <div class="world-bottom-nav__area__chat__badge" style="display: none;"></div>
  </div>
</section>
`;
  }

  /**
   * @param MeetingModeController controller
   * @param Model model
   */
  static init({ controller, model }) {
    this.controller = controller
    this.model = model

    const $container = $('#meetingModeContainer')
    const $badge = $container.find('.world-bottom-nav__area__chat__badge')
    const $chatToggle = $('#chat-list-navbar-button');

    let chatPanel = null;

    const openChatPanel = () => {
      const currentSceneId = model.config.currentSceneId
      if (!currentSceneId) {
        return
      }

      const $meetingPanelBackButton = $(`#${currentSceneId}.chat-container .back-button`)

      // this.model.dispatchEvent({ type: CHAT_EVENTS.OPEN_SCENE_CHAT, data: { id: currentSceneId } })
      $container.addClass('on-chat-open')
      $chatToggle.addClass('selected')
      $meetingPanelBackButton.hide();

      if (!chatPanel) {
        chatPanel = this.model.chatPanel?.sceneChats?.[currentSceneId]

        if (chatPanel) {
          chatPanel.addEventListener('closed', () => {
            $container.removeClass('on-chat-open')
            $chatToggle.removeClass('selected')
            $meetingPanelBackButton.show();
          })
        }
      }
    }

    this.model.addEventListener(SCENE_INTERACTION.CHAT_PANEL_OPENED, () => {
      $container.addClass('on-chat-open')
      $chatToggle.addClass('selected')
    })
    this.model.socket.addEventListener(SOCKET_EVENTS.ADD_ONE_ON_ONE_CHAT, () => {
      $container.addClass('on-chat-open')
    });
    this.model.addEventListener(CHAT_EVENTS.OPEN_WORLD_CHAT, () => {
      $container.addClass('on-chat-open')
      $chatToggle.addClass('selected')
    })
    this.model.addEventListener(CHAT_EVENTS.OPEN_SCENE_CHAT, () => {
      $container.addClass('on-chat-open')
      $chatToggle.addClass('selected')
    })
    this.model.addEventListener(CHAT_EVENTS.OPEN_CHESS_CHAT, () => {
      $container.addClass('on-chat-open')
      $chatToggle.addClass('selected')
    })
    this.model.addEventListener(CHAT_EVENTS.OPEN_ONE_ON_ONE, () => {
      $container.addClass('on-chat-open')
      $chatToggle.addClass('selected')
    })

    this.model.addEventListener(CHAT_EVENTS.CLOSE_BUTTON_CLICKED_ON_SINGLE_CHAT, () => {
      $container.removeClass('on-chat-open')
      $chatToggle.removeClass('selected')
    })
    this.model.addEventListener(SCENE_INTERACTION.CHAT_PANEL_CLOSED, () => {
      $container.removeClass('on-chat-open')
      $chatToggle.removeClass('selected')
    })


    this.model.addEventListener("REMOVE_STREAM", (e) => {
      if (!this.controller?.meetingModeContainer?.pinnedMedia) {
        this.controller?.meetingModeContainer?.$template.removeClass('screen-sharing-active');
      }
      if (this.controller?.meetingModeContainer?.pinnedMedia) {
        const { socketUser } = this.controller?.meetingModeContainer?.pinnedMedia;
        const id = e.data.id;
        const userId = id.split("CAMERA")[1] || id.split("SCREEN")[1];
        if (userId === socketUser.userId) {
          this.controller?.meetingModeContainer?.$template.removeClass('screen-sharing-active');
        }
      }
    });

    this.model.addEventListener(SCENE_INTERACTION.USER_CLICKED_STOP_SCREEN_SHARE_BUTTON_IN_MEETING_MODE, (e) => {
      if (this.controller?.meetingModeContainer?.pinnedMedia) {
        const { socketUser } = this.controller?.meetingModeContainer?.pinnedMedia;
        if (socketUser.userId === this.model.config.userId) {
          this.controller?.meetingModeContainer?.$template.removeClass('screen-sharing-active');
        }
      }
    });

    this.model.chatPanel?.chatNotifications?.addEventListener(CHAT_NOTIFICATION.CHANGED, (e) => {
      const { data } = e;
      const currentSceneId = model.config.currentSceneId

      if (!currentSceneId || !data?.SCENE?.[currentSceneId]) {
        return
      }

      const numOfUnreadMessage = data.SCENE[currentSceneId] ?? 0

      if (numOfUnreadMessage > 0) {
        $badge.text(numOfUnreadMessage)
        $badge.show()
      } else {
        $badge.hide()
      }
    })
    //   this.model.dispatchEvent({ type: SCENE_INTERACTION.PEOPLE_PANEL_OPENED });
    this.model.addEventListener(SCENE_INTERACTION.PEOPLE_PANEL_OPENED, () => {
      $container.addClass('on-chat-open')
    });
    this.model.addEventListener(SCENE_INTERACTION.PEOPLE_PANEL_CLOSED, () => {
      if ($(".chat-container").is(":visible")) {
        return;
      }
      $container.removeClass('on-chat-open')
    });
  }
}

export class OwnChairMenu extends BottomNavbarCenterMenu {
  constructor({ model }) {
    super()
    this.model = model;
    this.actionWrapper = $(this.template());

    this.$audioTrackControl = this.actionWrapper.find("#toggleAudioTrack");
    this.$videoTrackControl = this.actionWrapper.find("#toggleVideoTrack");
    this.$meetingModeControl = this.actionWrapper.find(".own_chair__controls__toggle-meeting-mode");
    this.$screenShareControl = this.actionWrapper.find(".own_chair__controls__screen-share");
    this.$stopScreenShareControl = this.actionWrapper.find(".own_chair__controls__stop-screen-share");

    this.init();
  }

  static selector() {
    return $('#own-chair-menu')
  }

  init() {
    OwnChairMenu.attach(this.actionWrapper)
    this.initListeners();
    OwnChairMenu.hide();
    this.$stopScreenShareControl.hide();
  }

  template() {
    return `
      <section id="own-chair-menu" class="world-bottom-nav__area world-bottom-nav__center_area">
        ${ControlMeetingModeButton.template()}
        ${ControlScreenShareButton.template()}
        ${ControlStopScreenShareButton.template()}
        ${ControlSeatMicButton.template()}
        ${ControlSeatCameraButton.template()}
        ${ControlExitModeButton.template()}
      </section>
    `;
  }

  initListeners() {
    const hideEvents = [
      SCENE_INTERACTION.SET_OCCUPIED_SEATS,
      SCENE_EVENTS.TOUR_MODE_ENDED,
      SCENE_EVENTS.GUIDED_MODE_STOP,
      SCENE_EVENTS.GUIDE_MODE_OFF,
      SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA,
      SCENE_EVENTS.TOUR_MODE_WINDOW_CLOSED,
      SCENE_EVENTS.TOUR_ROOM_LEFT,
    ];
    hideEvents.forEach((eventName) => {
      this.model.addEventListener(eventName, (e) => {
        if (eventName === SCENE_EVENTS.GUIDED_MODE_STOP || eventName === SCENE_EVENTS.GUIDE_MODE_OFF || eventName === SCENE_EVENTS.TOUR_MODE_ENDED || eventName === SCENE_EVENTS.TOUR_MODE_WINDOW_CLOSED || eventName === SCENE_EVENTS.TOUR_ROOM_LEFT) {
          this.model.syncButtonNavUI(true);
        } else {
          this.model.syncButtonNavUI();
        }
      });
    });
    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_MIC_ON, (e) => {
      this.$audioTrackControl.removeClass("is-off");
    });
    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_MIC_OFF, (e) => {
      this.$audioTrackControl.addClass("is-off");
    });

    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_CAMERA_ON, (e) => {
      this.$videoTrackControl.removeClass("is-off");
    });
    this.model.addEventListener(SCENE_EVENTS.USER_SEAT_TURN_CAMERA_OFF, (e) => {
      this.$videoTrackControl.addClass("is-off");
    });
    this.model.addEventListener(SCENE_EVENTS.SHOW_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU, (e) => {
      this.$screenShareControl.removeClass('look-disabled');
      this.$screenShareControl.show();
      this.$stopScreenShareControl.hide();
    });
    this.model.addEventListener(SCENE_EVENTS.HIDE_SCREEN_SHARE_BUTTON_IN_OWN_USER_MENU, (e) => {
      this.$screenShareControl.addClass('look-disabled');
      if (this.model.view.iSitOnScreenStream()) {
        this.$screenShareControl.hide();
        this.$stopScreenShareControl.show();
      }
    });
    this.model.addEventListener(SCENE_EVENTS.TINY_WORLD_ANIMATION_ENDED, (e) => {
      if (!this.model.view?.filtered3DObjects["tourScreenShare"] || this.model.view?.filtered3DObjects["tourScreenShare"]?.length < 1) {
        this.$screenShareControl.addClass('look-disabled');
      } else {
        this.$screenShareControl.removeClass('look-disabled');
      }
    });
    this.model.addEventListener(SCENE_EVENTS.SCENE_CHANGED, (e) => {
      if (!this.model.view?.filtered3DObjects["tourScreenShare"] || this.model.view?.filtered3DObjects["tourScreenShare"]?.length < 1) {
        this.$screenShareControl.addClass('look-disabled');
      } else {
        this.$screenShareControl.removeClass('look-disabled');
      }
    });
    //show hide grid mode button selection
    this.model.addEventListener(SCENE_EVENTS.GRID_MODE, (e) => {
      this.$meetingModeControl.toggleClass('selected', e.data.showGrid);
    });

    // Show own chair menu on JOIN_ROOM_SUCESS
    this.model.addEventListener(ANT_MEDIA_SERVER_BAGELSS_EVENTS.JOIN_ROOM_SUCESS, () => {
      if (this.model.iSitOnThisVRChair) {
        OwnChairMenu.show();
      }
    });

    this.$meetingModeControl.on('click', () => {
      this.model.view.handleGridToggle?.();
      this.$meetingModeControl.toggleClass('selected', $('#meetingModeContainer:visible').length > 0);
      this.model.dispatchEvent({ type: CHAT_EVENTS.JUST_CLOSE_CHAT_UI });
    });

    this.$screenShareControl.on('click', async () => {
      if (this.$screenShareControl.hasClass('look-disabled')) {
        this.model.alert('error', $trans('error-screen-share-occupied'));
        return;
      }

      if (!await this.model.validatePlanFeature(FEATURE_NAMES.UNLIMITED_SCREENSHARE)) {
        return;
      }

      if (this.model.view.isMeSharing()) {
        this.model.view._stopScreenShare();
        this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_CLICKED_STOP_SCREEN_SHARE_BUTTON_IN_MEETING_MODE });
        return;
      }

      this.model.view.takeFirstEmptyScreenShareSeat();
    });

    this.$stopScreenShareControl.on('click', () => {
      this.model.view._stopScreenShare();
      this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_CLICKED_STOP_SCREEN_SHARE_BUTTON_IN_MEETING_MODE });
    });
  }
}

export class OwnVapiMenu extends BottomNavbarCenterMenu {
  constructor({ model }) {
    super()
    OwnVapiMenu.instance = this;
    this.model = model;
    this.actionWrapper = $(this.template());

    this.$audioTrackControl = this.actionWrapper.find("#toggleVapiAudioTrack");
    this.$videoTrackControl = this.actionWrapper.find("#toggleVapiVideoTrack");
    this.$endCallControl = this.actionWrapper.find("#leave-vapi-call");

    this.init();
  }

  static selector() {
    return $('#own-vapi-menu')
  }

  static show() {
    super.show();
    this.instance?.subtitles?.followMenu();
  }

  init() {
    OwnVapiMenu.attach(this.actionWrapper)
    this.subtitles = new OwnVapiMenuSubtitles({
      model: this.model,
      getAgentId: () => {
        const chair = this.getActiveChair();
        return chair?._getAgentId?.() ?? this._getChairVapiAgentId(chair);
      },
    });
    this.initListeners();
    OwnVapiMenu.hide();
  }

  template() {
    return `
      <section id="own-vapi-menu" class="world-bottom-nav__area world-bottom-nav__center_area">
        ${ControlVapiMicButton.template()}
        ${ControlVapiCameraButton.template()}
        ${ControlVapiEndButton.template()}
      </section>
    `;
  }

  getActiveChair() {
    return this.model.getActiveVapiChair?.() || null;
  }

  /** Same agent key as VRVapiChairWithCSS3D._getAgentId — must match vapiUserCamera.dbConfig.vapiAgentId. */
  _getChairVapiAgentId(chair) {
    if (!chair) return null;
    return chair.dbConfig?.id ?? chair.getId?.() ?? chair.id ?? null;
  }

  getActiveChairCameras() {
    const chair = this.getActiveChair();
    const chairId = this._getChairVapiAgentId(chair);
    if (!chairId || chair?.dbConfig?.components?.camera?.active === false) {
      return [];
    }
    return (this.model.view?.vraiAgentCameras || []).filter((camera) => {
      return String(camera?.dbConfig?.vapiAgentId) === String(chairId);
    });
  }

  syncState() {
    const chair = this.getActiveChair();
    this.$audioTrackControl.toggleClass('is-off', !!chair?._isMicMuted);
    this.$videoTrackControl.toggleClass('is-off', !!chair?._isCameraHidden);
    // Always show camera mute while in a call (same as mic). `components.camera.active` only toggles
    // the CSS3D scene camera in the room; default vraiAgent templates ship with camera.active false.
    this.$videoTrackControl.toggle(!!chair);
  }

  initListeners() {
    const syncMenu = () => {
      this.syncState();
      this.model.syncButtonNavUI();
    };

    const hideEvents = [
      SCENE_INTERACTION.SET_OCCUPIED_SEATS,
      SCENE_EVENTS.TOUR_MODE_ENDED,
      SCENE_EVENTS.GUIDED_MODE_STOP,
      SCENE_EVENTS.GUIDE_MODE_OFF,
      SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA,
      SCENE_EVENTS.TOUR_MODE_WINDOW_CLOSED,
      SCENE_EVENTS.TOUR_ROOM_LEFT,
      SCENE_EVENTS.SCENE_CHANGED,
    ];

    hideEvents.forEach((eventName) => {
      this.model.addEventListener(eventName, () => {
        this.syncState();
        this.model.syncButtonNavUI();
      });
    });

    this.model.addEventListener('vapi-agent-call-start', syncMenu);
    this.model.addEventListener('vapi-agent-call-end', syncMenu);
    this.model.addEventListener('vapi-agent-status', syncMenu);
    this.model.addEventListener('vapi-agent-error', syncMenu);
    this.model.addEventListener('vapi-agent-media', syncMenu);

    this.$audioTrackControl.on('click', () => {
      const chair = this.getActiveChair();
      if (!chair) {
        return;
      }
      chair.setMicrophoneMuted?.(!chair._isMicMuted);
      this.syncState();
    });

    this.$videoTrackControl.on('click', () => {
      const chair = this.getActiveChair();
      if (!chair) {
        return;
      }
      chair.setCameraHidden?.(!chair._isCameraHidden);
      this.syncState();
    });

    this.$endCallControl.on('click', () => {
      const chair = this.getActiveChair();
      const agentId = chair?._getAgentId?.() ?? chair?.id;
      if (chair && this.model?.dispatchEvent && agentId != null) {
        this.model.dispatchEvent({
          type: SCENE_INTERACTION.END_VAPI_CALL,
          data: { vapiAgentId: agentId },
        });
      } else {
        chair?._endCall?.();
      }
    });
  }

  hide() {
    OwnVapiMenu.hideAllBottomNavMenu();
    this.model.syncButtonNavUI();
  }
}

class ControlSeatMicButton {
  static template() {
    return `
      <div id='toggleAudioTrack' class="world-bottom-nav__area__item own_chair__controls__mic">
        ${ICON.MIC_ON}
        ${ICON.MIC_OFF}
      </div>
    `;
  }
}

class ControlSeatCameraButton {
  static template() {
    return `
<div id='toggleVideoTrack' class="world-bottom-nav__area__item own_chair__controls__camera">
  ${ICON.CAMERA_ON}
  ${ICON.CAMERA_OFF}
</div>
    `;
  }
}

class ControlExitModeButton {
  static template() {
    return `
<div id="leave-chair" class="world-bottom-nav__area__item world-bottom-nav__area__exit own_chair__controls__exit">
  ${ICON.CHAIR}
  <div class="own_chair__controls__exit__close-icon">
    ${ICON.CLOSE}
  </div>
</div>
    `;
  }
}

class ControlScreenShareButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item own_chair__controls__screen-share">
  ${ICON.SHARE_SCREEN}
</div>
    `;
  }
}
class ControlStopScreenShareButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item own_chair__controls__stop-screen-share">
  ${ICON.STOP_SCREEN_SHARE}
</div>
    `;
  }
}

class ControlMeetingModeButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item own_chair__controls__toggle-meeting-mode">
  ${ICON.GRID}
</div>
    `;
  }
}

class ControlVapiMicButton {
  static template() {
    return `
<div id='toggleVapiAudioTrack' class="world-bottom-nav__area__item own_chair__controls__mic">
  ${ICON.MIC_ON}
  ${ICON.MIC_OFF}
</div>
    `;
  }
}

class ControlVapiCameraButton {
  static template() {
    return `
<div id='toggleVapiVideoTrack' class="world-bottom-nav__area__item own_chair__controls__camera">
  ${ICON.CAMERA_ON}
  ${ICON.CAMERA_OFF}
</div>
    `;
  }
}

class ControlVapiEndButton {
  static template() {
    return `
<div id="leave-vapi-call" class="world-bottom-nav__area__item world-bottom-nav__area__exit own_chair__controls__exit">
  ${ICON.CALL_HANGUP}
</div>
    `;
  }
}

export class MeetingPinnedMediaContainer {
  constructor() {
    this.$template = $(this.template());
    this.$template.data('container', this);

    this.$elements = {
      video: this.$template.find('.meeting-mode__media'),
      name: this.$template.find('.meeting-mode__name'),
      fullscreenButton: this.$template.find('.meeting-mode__media__screen-controls__fullscreen'),
      exitFullscreenButton: this.$template.find('.meeting-mode__media__screen-controls__exit-fullscreen')
    }

    // Setup fullscreen controls
    this.setupFullscreenControls();
  }

  template() {
    return `
<div class="meeting-mode__media-container pinned-video">
  <video class="meeting-mode__media" autoplay playsinline muted></video>
  <div class="meeting-mode__name"></div>
  <div class="meeting-mode__media__screen-controls">
    <div class="meeting-mode__media__screen-controls__fullscreen" title="Enter fullscreen">
      ${ICON.MAKE_FULLSCREEN}
    </div>
    <div class="meeting-mode__media__screen-controls__exit-fullscreen" title="Exit fullscreen" style="display: none;">
      ${ICON.EXIT_FULLSCREEN}
    </div>
  </div>
</div>
    `;
  }

  pinMedia(media) {
    this.sourceMedia = media;
    this.updateFromSource();
  }

  updateFromSource() {
    // Copy user info
    const userId = this.sourceMedia.$template.data('userId');
    const name = this.sourceMedia.$template.data('name');

    if (userId) this.$template.data('userId', userId);
    if (name) {
      this.$template.data('name', name);
      this.$elements.name.text(name);
    }

    // Set video stream
    const sourceVideo = this.sourceMedia.$elements.video[0];
    if (sourceVideo && sourceVideo.srcObject) {
      const videoElement = this.$elements.video[0];
      videoElement.srcObject = sourceVideo.srcObject;
      videoElement.muted = true; // Ensure it's muted
      videoElement.play().catch(e => console.error('Error playing pinned video:', e));
    }
  }

  setupFullscreenControls() {
    // Handle fullscreen button click
    this.$elements.fullscreenButton.on('click', () => {
      this.toggleFullscreen();
    });

    // Handle exit fullscreen button click
    this.$elements.exitFullscreenButton.on('click', () => {
      this.toggleFullscreen();
    });

    // Listen for fullscreen change events
    document.addEventListener('fullscreenchange', this.handleFullscreenChange.bind(this));
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange.bind(this));
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange.bind(this));
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange.bind(this));
  }

  handleFullscreenChange() {
    if (isFullscreen()) {
      this.$elements.fullscreenButton.hide();
      this.$elements.exitFullscreenButton.show();
    } else {
      this.$elements.exitFullscreenButton.hide();
      this.$elements.fullscreenButton.show();
    }
  }

  async toggleFullscreen() {
    try {
      // Get the container element (not just the video)
      const containerElement = this.$template[0];

      if (!containerElement) {
        console.error('Pinned video container element not found');
        return;
      }

      // Use the toggleFullscreen helper function on the container
      await toggleFullscreen(containerElement);

      this.handleFullscreenChange();
    } catch (error) {
      console.error('Error toggling fullscreen mode:', error);
    }
  }

  remove() {
    // Remove fullscreen event listeners
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange.bind(this));
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange.bind(this));
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange.bind(this));
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange.bind(this));

    // Clean up any resources
    const videoElement = this.$elements.video[0];
    if (videoElement && videoElement.srcObject) {
      videoElement.srcObject = null;
    }

    this.$template.remove();
  }
}

export class MeetingMediaContainer {
  constructor({ model, socketUser }) {
    this.model = model
    this.socketUser = socketUser

    this.$template = $(this.template());

    this.$template.data('container', this);

    this.$elements = {
      avatar: this.$template.find('.meeting-mode__avatar'),
      video: this.$template.find('.meeting-mode__media'),
      name: this.$template.find('.meeting-mode__name'),
      audioIndicator: this.$template.find('.one-on-one__media__audio-indicator'),
      muteIndicator: this.$template.find('.one-on-one__media__mute-indicator'),
    }

    this.streamId = null

    this.initOtherUserMicControl();

    // Add click handler to the container
    this.$template.on('click', () => {
      // Find the parent container that has this media item
      const meetingContainer = $('#meetingModeContainer').data('container');
      if (meetingContainer && typeof meetingContainer.setPinnedMedia === 'function') {
        meetingContainer.setPinnedMedia(this);
      }
    });
  }

  template() {
    return `
<div class="meeting-mode__media-container speaking-outline">
  <img
      class='meeting-mode__avatar'
      onError='this.src = "/textures/defaultAvatar.png"'
      alt='Avatar image'
    />
    <video
      class='meeting-mode__media'
      autoplay playsinline muted
    ></video>
    <div class="meeting-mode__name"></div>
    <div
      class="one-on-one__media__audio-indicator meeting-mode__mic-toggle"
    >
      <span></span><span></span><span></span>
    </div>
    <div
      class="one-on-one__media__mute-indicator meeting-mode__mic-toggle"
      style="display: none;"
    >
      ${ICON.MIC_OFF}
    </div>
</div>
  `
  }

  updateUserInfo({ userId, name, avatarUrl }) {
    this.$elements.name.text(name)
    this.$elements.avatar.attr('src', avatarUrl)
    this.$template.attr('data-user-id', userId)
    this.syncOtherUserMicControl()
  }

  initOtherUserMicControl() {
    const onMicClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (this.model.config.isGuest) {
        return;
      }
      if (String(this.socketUser?.userId) === String(this.model.config.userId)) {
        return;
      }
      const user = this.model.socket.getUsersObject()?.[this.socketUser.userId] || this.socketUser;
      this.model.requestToggleOtherUserMic(user, true);
    };

    this.$elements.audioIndicator.on('click', onMicClick);
    this.$elements.muteIndicator.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    this.syncOtherUserMicControl();
  }

  syncOtherUserMicControl() {
    const isOtherUser = String(this.socketUser?.userId) !== String(this.model.config.userId);
    const canMute = isOtherUser && !this.model.config.isGuest;
    this.$elements.audioIndicator.toggleClass('can-mute-other', canMute);
    this.$elements.muteIndicator.removeClass('can-mute-other');
    this.$elements.audioIndicator.attr('title', canMute ? $trans('turn-mic-off-text') : '');
    this.$elements.muteIndicator.attr('title', '');
  }

  updateMediaUI({ userAudioMuted = null, userVideoMuted = null }) {
    if (userAudioMuted !== null) {
      if (userAudioMuted) {
        this.$elements.audioIndicator.hide()
        this.$elements.muteIndicator.show()
      } else {
        this.$elements.audioIndicator.show()
        this.$elements.muteIndicator.hide()
      }
    }

    if (userVideoMuted !== null) {
      if (userVideoMuted) {
        this.$elements.video.hide()
        this.$elements.avatar.show()
      } else {
        this.$elements.video.show()
        this.$elements.avatar.hide()
      }
    }
  }

  setVideoStream(stream, configs = {}) {
    const videoElement = this.$elements.video.get(0)
    if (configs?.preprocess) {
      configs.preprocess(videoElement)
    }

    if (this.streamId !== stream?.id) {
      if (configs?.onVideoReady) {
        const onceFunction = () => {
          configs.onVideoReady(videoElement)
          videoElement.removeEventListener('loadedmetadata', onceFunction)
        }
        videoElement.addEventListener('loadedmetadata', onceFunction)
      }

      videoElement.srcObject = stream
      this.streamId = stream.id
    }

    if (configs?.callback) {
      configs.callback(videoElement)
    }
  }

  setMicTestHandler(stream) {
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    this.volumeAnalyser = new VolumeAnalyser({
      stream,
      audioContext: this.audioContext,
      onSpeakingChanged: (speaking) => {
        this.$elements.audioIndicator.toggleClass('speaking-indicator--active', speaking)
      }
    })

    this.model.registerAudioAnalyzer(this.volumeAnalyser)
  }

  resetUserMood() {
    this.$template.removeClass('speaking-outline--green-mood')
    this.$template.removeClass('speaking-outline--yellow-mood')
    this.$template.removeClass('speaking-outline--red-mood')
  }

  setUserMood(mood) {
    this.resetUserMood();
    switch (String(mood)) {
      case '1':
        this.$template.addClass('speaking-outline--green-mood')
        break
      case '2':
        this.$template.addClass('speaking-outline--yellow-mood')
        break
      case '3':
        this.$template.addClass('speaking-outline--red-mood')
        break
    }
  }

  removeMicTestHandler() {
    if (this.volumeAnalyser) {
      this.model.removeAudioAnalyzer(this.volumeAnalyser)
      this.volumeAnalyser.destroy()
      this.volumeAnalyser = null
    }
  }

  remove() {
    this.$template.remove()
    this.removeMicTestHandler()
  }
}

export class MeetingContainer {
  constructor({ controller, model }) {
    this.controller = controller
    this.model = model

    this.$template = $(this.template());
    this.$template.data('container', this);

    $("body").append(this.$template);

    this.$grid = this.$template.find('.meeting-mode__grid');
    this.$pinned = this.$template.find('#pinned-content');

    // Add media tracking
    this.mediaItems = [];
    this.pinnedMedia = null;
    this.pinnedMediaContainer = null;

    this.addListeners();
  }

  addListeners() {
    this.model.addEventListener(SCENE_EVENTS.USER_INVERTS_CAMERA, (e) => {
      this.mediaItems.forEach(item => {
        if (item.socketUser.userId === this.model.config.userId) {
          const savedState = JSON.parse(localStorage.getItem('user_invert_camera_'));
          const isInverted = savedState?.state;
          const isScreenShare = this?.model?.streamController?.screenController?.webRTCAdaptor?.mediaManager?.localStream?.id;
          if (isScreenShare && isScreenShare !== item.streamId) {
            item.$template.find('video').toggleClass('invert', isInverted);
          } if (!isScreenShare) {
            item.$template.find('video').toggleClass('invert', isInverted);
          }
        }
      });
    });
  }

  template() {
    return `
<div id="meetingModeContainer" class="meeting-mode">
  <div class="meeting-mode__wrapper">
    <div class="meeting-mode__grid">

    </div>

    <div class="meeting-mode__pinned-area">
      <div class="meeting-mode__pinned-area__content" id="pinned-content">

      </div>
    </div>
  </div>
</div>
    `
  }

  videoRowTemplate(identifyClass) {
    return `
<div class="meeting-mode__video-row ${identifyClass}">
</div>
    `
  }

  show() {
    this.$template.addClass('meeting-mode--visible');
  }

  hide() {
    this.$template.removeClass('meeting-mode--visible');
  }

  isShown() {
    return this.$template.hasClass('meeting-mode--visible');
  }

  clear() {
    this.mediaItems = [];
    this.setPinnedMedia(null)
    this.$grid.empty();
    this.$pinned.empty();
  }

  safeClearGrid() {
    this.mediaItems.forEach(item => {
      item.$template.detach();
    })

    this.$grid.empty();
    this.$grid.css('display', '');
  }

  addMedia(media) {
    // Add media to tracking array if not already present
    if (!this.mediaItems.includes(media)) {
      this.mediaItems.push(media);
    }

    // Render the updated grid
    this.render();
  }

  removeMedia(media) {
    // First detach the media element from DOM
    media.$template.detach();

    // Remove from tracking array
    const index = this.mediaItems.indexOf(media);
    if (index !== -1) {
      this.mediaItems.splice(index, 1);
    }

    // If this was the pinned media, unpin it
    if (this.pinnedMedia === media) {
      this.pinnedMedia = null;
    }

    // Re-render the grid
    this.render();
  }

  setPinnedMedia(media) {
    if (this.pinnedMedia === media || media === null) {
      // Unpin if already pinned
      this.pinnedMedia = null;

      if (this.pinnedMediaContainer) {
        this.pinnedMediaContainer.remove();
        this.pinnedMediaContainer = null;
      }

      this.$template.removeClass('screen-sharing-active');
    } else {
      // Pin the media
      this.pinnedMedia = media;
      this.$template.addClass('screen-sharing-active');
    }

    // Re-render with the new pinned state
    this.render();
  }

  /**
   * Render the pinned media area and grid when a media is pinned.
   * @returns {boolean} true if pinned media is visible, false otherwise.
   */
  _renderPinnedMediaView() {
    if (!this.pinnedMedia) {
      this.$pinned.empty();
      this.$pinned.parent().hide();

      return false;
    }

    // Ensure pinned media container exists and update its content
    if (!this.pinnedMediaContainer) {
      this.pinnedMediaContainer = new MeetingPinnedMediaContainer();
    }
    this.pinnedMediaContainer.pinMedia(this.pinnedMedia);
    this.$pinned.append(this.pinnedMediaContainer.$template);
    this.$pinned.parent().show();

    this.$grid.addClass('meeting-mode__grid--scrollable');

    // Add all media items to the grid as a scrollable row, marking the pinned one
    this.mediaItems.forEach(item => {
      this.$grid.append(item.$template);
      if (item === this.pinnedMedia) {
        item.$template.addClass('active');
        item.$template.get(0).scrollIntoView();
      } else {
        item.$template.removeClass('active');
      }
    });

    return true
  }

  /**
   * Render grid when there are no media items.
   */
  _renderEmptyGrid() {
    this.$grid.css('display', 'none');
  }

  /**
   * Render grid for a single media item.
   */
  _renderOneItemGrid() {
    this.$grid.append(this.mediaItems[0].$template);
    this.$grid.addClass('meeting-mode__grid--1-item');
  }

  /**
   * Render grid for two media items.
   */
  _renderTwoItemsGrid() {
    this.mediaItems.forEach(item => {
      this.$grid.append(item.$template);
    });
    this.$grid.addClass('meeting-mode__grid--2-items');
  }

  /**
   * Render grid for exactly three media items (special layout: 2 top, 1 bottom).
   */
  _renderThreeItemsGrid() {
    this.$grid.addClass('meeting-mode__grid--3-items');

    const $topRow = $(this.videoRowTemplate('meeting-mode__video-row--top'));
    const $bottomRow = $(this.videoRowTemplate('meeting-mode__video-row--bottom'));

    $topRow.append(this.mediaItems[0].$template, this.mediaItems[1].$template);
    $bottomRow.append(this.mediaItems[2].$template);

    this.$grid.append($topRow, $bottomRow);
  }

  /**
   * Render grid for four or more media items (split into two rows).
   */
  _renderMultiItemsGrid() {
    this.$grid.addClass('meeting-mode__grid--multi-items');

    const $topRow = $(this.videoRowTemplate('meeting-mode__video-row--top'));
    const $bottomRow = $(this.videoRowTemplate('meeting-mode__video-row--bottom'));

    this.$grid.append($topRow, $bottomRow);

    const topRowCount = Math.ceil(this.mediaItems.length / 2);
    const bottomRowCount = this.mediaItems.length - topRowCount;

    if ($('body.is-mobile-mode.is-portrait-mode').length) {
      $topRow.css({ 'grid-template-rows': `repeat(${bottomRowCount}, 1fr)` });
      $bottomRow.css({ 'grid-template-rows': `repeat(${bottomRowCount}, 1fr)` });

      for (let i = 0; i < bottomRowCount; i++) {
        $topRow.append(this.mediaItems[i].$template)
      }
      for (let i = 0; i < bottomRowCount; i++) {
        $bottomRow.append(this.mediaItems[bottomRowCount + i].$template)
      }

      if (topRowCount > bottomRowCount) {
        this.$grid.append(this.mediaItems[this.mediaItems.length - 1].$template)
        this.$grid.css({ 'grid-template-rows': `${bottomRowCount}fr 1fr` });
      }
    } else {
      $topRow.css({ 'grid-template-columns': `repeat(${topRowCount}, 1fr)` });
      $bottomRow.css({ 'grid-template-columns': `repeat(${bottomRowCount}, 1fr)` });

      for (let i = 0; i < topRowCount; i++) {
        $topRow.append(this.mediaItems[i].$template)
      }
      for (let i = 0; i < bottomRowCount; i++) {
        $bottomRow.append(this.mediaItems[topRowCount + i].$template)
      }

      this.$grid.css({ 'grid-template-rows': '' });
    }
  }

  render() {
    // Remove all layout classes
    this.$grid.removeClass([
      'meeting-mode__grid--1-item',
      'meeting-mode__grid--2-items',
      'meeting-mode__grid--3-items',
      'meeting-mode__grid--multi-items',
      'meeting-mode__grid--scrollable',
    ].join(' '));

    this.safeClearGrid();

    // Case 1: Pinned media view
    const isPinnedVisible = this._renderPinnedMediaView();
    if (isPinnedVisible) {
      return;
    }
    const savedState = JSON.parse(localStorage.getItem('user_invert_camera_'));
    const isInverted = savedState?.state;
    this.mediaItems.forEach(item => {
      if (item.socketUser.userId === this.model.config.userId) {
        const isScreenShare = this?.model?.streamController?.screenController?.webRTCAdaptor?.mediaManager?.localStream?.id;
        if (isScreenShare && isScreenShare !== item.streamId) {
          item.$template.find('video').toggleClass('invert', isInverted);
        } if (!isScreenShare) {
          item.$template.find('video').toggleClass('invert', isInverted);
        }
      }
    });
    // Case 2: No media items
    if (this.mediaItems.length === 0) {
      this._renderEmptyGrid()
      return
    }

    // Case 3: Single media item
    if (this.mediaItems.length === 1) {
      this._renderOneItemGrid()
      return
    }

    // Case 4: Two media items
    if (this.mediaItems.length === 2) {
      this._renderTwoItemsGrid()
      return
    }

    // Case 5: Three media items
    if (this.mediaItems.length === 3) {
      this._renderThreeItemsGrid()
      return
    }

    // Case 6: Four or more media items
    this._renderMultiItemsGrid()
  }
}
